import { useEffect, useRef, useState } from "react";
import * as pdfjsLib from "pdfjs-dist";
import { Loader2 } from "lucide-react";

pdfjsLib.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL || ""}/pdf.worker.min.js`;

/** jsPDF çıktısını (arraybuffer) sayfa sayfa canvas'a çizer — ekranda görünen = indirilen PDF (birebir). */
export default function PdfPagesView({ data, width = 794, testid = "pdf-pages" }) {
  const [pages, setPages] = useState(0);
  const [busy, setBusy] = useState(false);
  const wrap = useRef(null);

  useEffect(() => {
    if (!data) return;
    let cancelled = false;
    (async () => {
      setBusy(true);
      try {
        const doc = await pdfjsLib.getDocument({ data: data.slice(0) }).promise;
        if (cancelled) return;
        setPages(doc.numPages);
        await new Promise((r) => requestAnimationFrame(r));
        // Yüksek çözünürlük: ekran dpr'inin 3 katı, genişliğe göre ~3400px ile sınırlı (bellek)
        const dpr = Math.max(1.5, Math.min(4, (window.devicePixelRatio || 1) * 3, 3400 / width));
        for (let i = 1; i <= doc.numPages; i++) {
          if (cancelled) return;
          const page = await doc.getPage(i);
          const base = page.getViewport({ scale: 1 });
          const scale = width / base.width;
          const vp = page.getViewport({ scale: scale * dpr });
          const canvas = wrap.current?.querySelector(`[data-page="${i}"]`);
          if (!canvas) continue;
          canvas.width = Math.floor(vp.width); canvas.height = Math.floor(vp.height);
          canvas.style.width = `${width}px`; canvas.style.height = `${Math.floor(vp.height / dpr)}px`;
          await page.render({ canvasContext: canvas.getContext("2d"), viewport: vp }).promise;
        }
      } catch (e) { console.error("pdf render", e); }
      finally { if (!cancelled) setBusy(false); }
    })();
    return () => { cancelled = true; };
  }, [data, width]);

  return (
    <div ref={wrap} className="relative mx-auto space-y-4" style={{ width }} data-testid={testid}>
      {busy && <div className="absolute inset-0 z-10 flex items-start justify-center pt-24 bg-white/60"><span className="inline-flex items-center gap-2 rounded-full bg-card border shadow px-4 py-2 text-sm font-semibold"><Loader2 className="h-4 w-4 animate-spin" />PDF hazırlanıyor…</span></div>}
      {Array.from({ length: pages }, (_, i) => (
        <canvas key={i} data-page={i + 1} className="block bg-white shadow-lg ring-1 ring-black/10 rounded-sm" data-testid={`${testid}-page-${i + 1}`} />
      ))}
      {!pages && !busy && <div className="py-24 text-center text-sm text-muted-foreground">Önizleme oluşturulamadı.</div>}
    </div>
  );
}
